import styled from 'styled-components'

// Adjustments for MOK
export const _ConfiguratorSection = styled.section`
  display: flex;
  /* flex-direction: column; */
  /* width: 100%; */
  /* padding-bottom: 10px; */
  padding: 30px 0;
  border-bottom: 1px solid #dddddd;
  flex-wrap: wrap;
  gap: 20px;

  @media (min-width: 1200px) {
    gap: 25px;
  }

  &:first-child > * {
    flex-basis: min-content;
  }

  /* .lfc-select-container label {
    margin-top: 5px;
  } */

  /* div select {
    :last-of-type {
      margin-bottom: 10px;
    }
  } */

  /* MOK */
  /* @media (min-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
  } */

  /* @media (min-width: 1024px) {
    > div {
      &.lfc-select-container select {
        width: 90%;
      }
    }
  } */

  /* &.thumnail {
    @media (min-width: 768px) {
      flex-direction: column;

      > div {
        margin-left: 0;
      }
    }

    @media (min-width: 1024px) {
      flex-direction: row;
    }
  } */

  &:last-of-type {
    border-bottom: none;
  }
`

// export const _DimensionalSelect = styled.div`
//   &.lfc-select-container {
//     width: 100%;
//   }

//   @media (min-width: 768px) {
//     flex-direction: column;

//     &.lfc-select-container {
//       width: 45%;

//       select {
//         width: 100%;
//       }
//     }
//   }

//   @media (min-width: 1024px) {
//     margin-left: 0;
//     margin-right: 30px;

//     ul {
//       flex-wrap: nowrap;
//     }

//     + div ul {
//       flex-wrap: wrap;
//     }
//   }
// `;
